import {
    requestInventory,
    getStylesFromInventory,
    requestVehicleParams,
    getClanInfo,
} from 'helpers/web_to_client'
import { arrayOrObjectToCamelCase } from 'helpers'
import { preloadImages } from 'containers/WGCWXShop/helpers'
import { ERROR_CODES, ERROR_ACTION_TYPES } from 'containers/WGCWXShop/errors'
import { REWARDS_TYPES } from 'containers/WGCWXShop/constants'

export const WGCWX_SHOP_PRODUCTS_REQUEST = 'wgcwx_shop/PRODUCTS_REQUEST'
export const WGCWX_SHOP_PRODUCTS_SUCCESS = 'wgcwx_shop/PRODUCTS_SUCCESS'
export const WGCWX_SHOP_PRODUCTS_ERROR = 'wgcwx_shop/PRODUCTS_ERROR'

export const WGCWX_SHOP_PURCHASE_REQUEST = 'wgcwx_shop/PURCHASE_REQUEST'
export const WGCWX_SHOP_PURCHASE_SUCCESS = 'wgcwx_shop/PURCHASE_SUCCESS'
export const WGCWX_SHOP_PURCHASE_ERROR = 'wgcwx_shop/PURCHASE_ERROR'
export const WGCWX_SHOP_CLEAR_ERROR = 'wgcwx_shop/CLEAR_ERROR'

export const WGCWX_SHOP_REWARDS_TANKS_REQUEST = 'wgcwx_shop/REWARDS_TANKS_REQUEST'
export const WGCWX_SHOP_REWARDS_TANKS_SUCCESS = 'wgcwx_shop/REWARDS_TANKS_SUCCESS'
export const WGCWX_SHOP_REWARDS_TANKS_ERROR = 'wgcwx_shop/REWARDS_TANKS_ERROR'

export const WGCWX_SHOP_REWARDS_TANK_ACTION_REQUEST = 'wgcwx_shop/REWARDS_TANK_ACTION_REQUEST'
export const WGCWX_SHOP_REWARDS_TANK_ACTION_SUCCESS = 'wgcwx_shop/REWARDS_TANK_ACTION_SUCCESS'
export const WGCWX_SHOP_REWARDS_TANK_ACTION_ERROR = 'wgcwx_shop/REWARDS_TANK_ACTION_ERROR'

export const WGCWX_INVENTORY_STYLES_SUCCESS = 'wgcwx_shop/INVENTORY_STYLES'

export const WGCWX_SHOP_IMAGE_PRELOAD_SUCCESS = 'wgcwx_shop/IMAGE_PRELOAD_SUCCESS'

export const WGCWX_SHOP_INNER_PAGE_STATE = 'wgcwx_shop/INNER_PAGE_STATE'

export const WGCWX_SHOP_CLAN_INFO_LOADED = 'wgcwx_shop/CLAN_INFO_LOADED'

export function requestShopGoods() {
    return async (dispatch, getState) => {
        const { wgcwxShopProducts, settings } = getState()
        if (wgcwxShopProducts.processing) return

        dispatch({ type: WGCWX_SHOP_PRODUCTS_REQUEST })
        try {
            const url = `${settings.gatewayHost}/global_map/wgapi/personal_shop/products/`
            const response = await fetch(url, { credentials: 'include' })
                .then(r => r.json().then(data => ({ ok: r.ok, body: data })))

            if (!response.ok) {
                const err = response.body
                throw new Error(err.title || err.description)
            }

            dispatch({
                type: WGCWX_SHOP_PRODUCTS_SUCCESS,
                payload: {
                    accountInfo: response.body.account_info,
                    goods: response.body.goods,
                },
            })
            const goods = getState().wgcwxShopProducts.goods

            dispatch(requestStylesFromInventory(
                Object.values(goods).filter(item => item.is_one_time_purchase).map(item => item.groups.root[0].cd)
            ))
        } catch (error) {
            dispatch({
                type: WGCWX_SHOP_PRODUCTS_ERROR,
                payload: {
                    errorActionType: ERROR_ACTION_TYPES.REQUEST_ITEMS,
                    errorMessage: error.message,
                },
            })
        }
    }
}

export function requestRewards() {
    return async (dispatch, getState) => {
        const { wgcwxShopRewards, wgcwxShopProducts, settings } = getState()
        if (wgcwxShopRewards.loading) return

        if (wgcwxShopProducts.errorActionType === ERROR_ACTION_TYPES.PURCHASE_ITEM) {
            dispatch({ type: WGCWX_SHOP_CLEAR_ERROR })
        }

        dispatch({ type: WGCWX_SHOP_REWARDS_TANKS_REQUEST })

        const url = `${settings.gatewayHost}/global_map/wgapi/personal_shop/rewards/`

        try {
            const inventory = await requestInventory()
            const response = await fetch(url, { credentials: 'include' })
                .then(r => r.json().then(data => ({ ok: r.ok, body: data })))

            if (!response.ok) {
                const err = response.body
                throw new Error(err.title || err.description)
            }

            const rewardsData = arrayOrObjectToCamelCase(response.body)

            const tanksParams = await Promise.all(rewardsData.goods.map(good => {
                if (good.type === REWARDS_TYPES.TANK) {
                    return requestVehicleParams(good.token)
                }
            }))
            rewardsData.goods = rewardsData.goods.map(good => {
                if (good.type === REWARDS_TYPES.TANK) {
                    const vehicleParams = tanksParams.find(({ vehicle }) => good.token === vehicle.vehicle_id)
                    const inHangar = !!inventory.find(inventoryVehicle => good.token === inventoryVehicle.id)

                    return {
                        ...good,
                        vehicleParams: vehicleParams ? arrayOrObjectToCamelCase(vehicleParams.vehicle) : null,
                        inHangar,
                    }
                }

                return good
            })

            dispatch({
                type: WGCWX_SHOP_REWARDS_TANKS_SUCCESS,
                payload: rewardsData,
            })
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH cannot request rewards', error)
            dispatch({
                type: WGCWX_SHOP_REWARDS_TANKS_ERROR,
                payload: {
                    errorActionType: ERROR_ACTION_TYPES.REQUEST_ITEMS,
                    errorMessage: error.message,
                },
            })
        }
    }
}

export function requestPreloadImages() {
    return async (dispatch) => {
        await preloadImages()

        dispatch({
            type: WGCWX_SHOP_IMAGE_PRELOAD_SUCCESS,
        })
    }
}

export function requestStylesFromInventory(styleIds) {
    return async (dispatch) => {
        const styles = await getStylesFromInventory(styleIds)

        dispatch({
            type: WGCWX_INVENTORY_STYLES_SUCCESS,
            payload: {
                styles,
            },
        })
    }
}

export function fetchClanInfo() {
    return async dispatch => {
        try {
            const clanInfo = await getClanInfo()
            dispatch({
                type: WGCWX_SHOP_CLAN_INFO_LOADED,
                payload: clanInfo,
            })
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH cannot request clan info', error)
            dispatch(error.message)
        }
    }
}

export function purchaseItem(productId) {
    return async (dispatch, getState) => {
        const { wgcwxShopProducts, settings } = getState()
        if (wgcwxShopProducts.processing) return

        dispatch({ type: WGCWX_SHOP_PURCHASE_REQUEST })
        try {
            const body = { product_id: productId }
            const url = `${settings.gatewayHost}/global_map/wgapi/personal_shop/products/`

            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
                credentials: 'include',
            })

            if (!response.ok) {
                const err = await response.json()
                throw new Error(err.title || err.description)
            }

            dispatch({ type: WGCWX_SHOP_PURCHASE_SUCCESS })
            dispatch(requestShopGoods())
            dispatch(requestRewards())
        } catch (error) {
            dispatch({
                type: WGCWX_SHOP_PURCHASE_ERROR,
                payload: {
                    errorActionType: ERROR_ACTION_TYPES.PURCHASE_ITEM,
                    errorMessage: error.message,
                },
            })
        }
    }
}

export function makeRewardAuctionBet(bet, productId) {
    return async (dispatch, getState) => {
        const { wgcwxShopRewards, settings } = getState()
        if (wgcwxShopRewards.processing) return
        dispatch({ type: WGCWX_SHOP_REWARDS_TANK_ACTION_REQUEST })

        try {
            const body = {
                product_id: productId,
                bet,
            }
            const url = `${settings.gatewayHost}/global_map/wgapi/personal_shop/auction_bet/`
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
                credentials: 'include',
            })

            if (!response.ok) {
                const err = await response.json()
                const errCode = (err.title || err.description)
                if (errCode !== ERROR_CODES.BET_IS_LOWER_THAN_MINIMUM) {
                    throw new Error(errCode)
                }
            }

            dispatch({ type: WGCWX_SHOP_REWARDS_TANK_ACTION_SUCCESS })
            dispatch(requestRewards())
        } catch (error) {
            dispatch({
                type: WGCWX_SHOP_REWARDS_TANK_ACTION_ERROR,
                payload: {
                    errorMessage: error.message,
                    errorActionType: ERROR_ACTION_TYPES.MAKE_TANK_BET,
                },
            })
        }
    }
}

export function cancelRewardAuctionBet() {
    return async (dispatch, getState) => {
        const { wgcwxShopRewards, settings } = getState()
        if (wgcwxShopRewards.processing) return
        dispatch({ type: WGCWX_SHOP_REWARDS_TANK_ACTION_REQUEST })

        try {
            const url = `${settings.gatewayHost}/global_map/wgapi/personal_shop/auction_bet/`
            const response = await fetch(url, {
                method: 'DELETE',
                credentials: 'include',
            })

            if (!response.ok) {
                const err = await response.json()
                throw new Error(err.title || err.description)
            }

            dispatch({ type: WGCWX_SHOP_REWARDS_TANK_ACTION_SUCCESS })
            dispatch(requestRewards())
        } catch (error) {
            dispatch({
                type: WGCWX_SHOP_REWARDS_TANK_ACTION_ERROR,
                payload: {
                    errorMessage: error.message,
                    errorActionType: ERROR_ACTION_TYPES.CANCEL_TANK_BET,
                },
            })
        }
    }
}

export function setShopInnerPageState(innerPageOpened) {
    return async (dispatch) => {
        dispatch({
            type: WGCWX_SHOP_INNER_PAGE_STATE,
            payload: {
                innerPageOpened,
            },
        })
    }
}



// WEBPACK FOOTER //
// ./state/actions/wgcwx_shop.js